import { StylesConfig } from 'react-select';
import { ComboBoxPrediction, ErrorLevel, IsMulti, Location } from './types';

export const GOOGLE_MAP_ID = '4e4c6d6b2e533fe8';

export const CLINIC_LOCATION_TEST_GUID = '15001-1'; //cl.clinic_location_guid
export const MARKETPLACE_PRACTITIONER_LOCATION_TEST_ID = '15001-1_1'; //staff_member_guid, '_', clinic_location_id

export enum Views {
  Map = 'map',
  List = 'list',
  Both = 'both',
}

export enum AvailabilityFilters {
  All = 'all',
  Today = 'today',
  Tomorrow = 'tomorrow',
  WithinAWeek = 'within-a-week',
}

type Disciplines = {
  [key: string]: string;
};

export const Disciplines: Disciplines = {
  acupuncture: 'Acupuncture',
  chiropractic: 'Chiropractic',
  massage_therapy: 'Massage Therapy',
  physiotherapy: 'Physiotherapy',
};

export const mobileBreakpoint = 769;

export const defaultMapLocation: Location = {
  coordinates: { lat: 49.72840186073827, lng: -123.13376941690414 },
  value: 'Squamish, BC, Canada',
};

// initial (roughly 5km) bounding box around defaultMapLocation
export const defaultMapBounds: google.maps.LatLngBoundsLiteral = {
  north: 49.7755207158905,
  south: 49.688973574338455,
  east: -123.06744009756643,
  west: -123.1861430586095,
};

// TODO: Common styles should not be in utilities. Move to components
// TODO: Should be renamed to comboBoxStyles
export const inputBaseStyles: StylesConfig<ComboBoxPrediction, IsMulti> = {
  control: (base, state) => ({
    ...base,
    outline: state.isFocused ? '2px solid #00787d' : 'none',
    outlineOffset: '2px',
    border: '1px solid #BCC6C6',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #BCC6C6',
    },
    height: '1.5rem',
  }),
  menu: (base) => ({
    ...base,
    marginBottom: 0,
    marginTop: 1,
    border: 'none',
    boxShadow: '0px 1px 12px 0px rgba(0, 0, 0, 0.10)',
    borderRadius: '0 0 4px 4px',
    padding: 0,
  }),
  option: (base, state) => ({
    ...base,
    cursor: 'pointer',
    padding: '0.5rem 1rem',
    '&:hover': {
      backgroundColor: '#EBEEEE',
    },
    backgroundColor: state.isFocused ? '#EBEEEE' : 'inherit',
    color: 'inherit',
  }),
  menuList: (base) => ({
    ...base,
    fontWeight: 600,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    fontWeight: 600,
  }),
};

/*AutocompleteService error messages*/
export const MESSAGES = {
  invalidRequest: {
    userMessage: 'This request was invalid. Refresh and try again.',
    message: '<LocationInput/>: This request was invalid.',
    type: ErrorLevel.Warning,
  },
  notFound: {
    userMessage: 'No matching locations found. Try another search.',
    message: '<LocationInput/>: The place referenced was not found.',
    type: ErrorLevel.Warning,
  },
  overQueryLimit: {
    userMessage: 'Google request limit has been reached.',
    message:
      '<LocationInput/>: The application has gone over its request quota.',
    type: ErrorLevel.Error,
  },
  requestDenied: {
    userMessage: 'Something went wrong. Refresh and try again.',
    message:
      'The application is not allowed to use the <code>PlacesService</code>',
    type: ErrorLevel.Error,
  },
  unknownError: {
    userMessage: 'Something went wrong. Refresh and try again.',
    message:
      '<LocationInput/>: The PlacesService request could not be processed due to a server error. The request may succeed if you try again.',
    type: ErrorLevel.Error,
  },
  zeroResults: {
    userMessage: 'No matching locations found. Try another search.',
    message: '<LocationInput/>: No result was found for this request.',
    type: ErrorLevel.Warning,
  },
  placesServiceError: {
    userMessage: 'Something went wrong. Refresh and try again.',
    message:
      '<LocationInput/>: Error loading places libraries for <LocationInput /> (geocoding and autocomplete).',
    type: ErrorLevel.Error,
  },
  serviceAreaError: {
    userMessage: 'No locations found within service area. Try another search.',
    message: '<LocationInput/>: All predictions were outside the service area.',
    type: ErrorLevel.Warning,
  },
};

export const MENU_ITEMS = [
  {
    label: 'Leave feedback',
    href: 'https://forms.gle/NCJux4CF875QhsbKA',
  },
  {
    label: 'Help & support',
    href: 'https://jane.app/guide/practitioner-search-for-patients',
  },
  {
    label: 'Privacy policy',
    href: 'https://jane.app/legal/privacy-notice',
  },
];

export enum OpeningBadgeStatus {
  AVAILABLE_TODAY = 'Available today',
  AVAILABLE_TOMORROW = 'Available tomorrow',
  AVAILABLE_THIS_WEEK = 'Available within a week',
}
